

exports.__esModule = true;
exports.$Middleware = void 0;
var _angular = require("angular");
var _logger = require("xo-beaver/dist/logger");
var _index = require("xo-models/src/user/index");
var _index2 = require("xo-models/src/checkout/index");
var _miniBrowser = require("./miniBrowser");
var _xoAPayUtils = require("xo-models/src/auth/lib/xoAPayUtils");
var _index3 = require("xo-models/src/onboard/index");
var _index4 = require("xo-models/src/auth/index");
var _squid = require("squid");
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var noop = function noop() {
  return undefined;
};

// making sure query param locale is in the format en_<XX>.
var isLocaleQueryParamValid = function isLocaleQueryParamValid(locale, token) {
  var isString = typeof locale === 'string' || locale instanceof String;
  if (!locale || !isString) {
    return false;
  }
  locale = locale.replace('-', '_');
  var valid = locale.match(/^\w{2}_\w{2}$/) ? true : false;
  _logger.$logger.info("xoon_isLocaleQueryParamValid_" + valid, {
    token: token,
    locale: locale
  });
  return valid;
};

/* Purpose of this method:
// overriding the resolvers(ipCountry/ localeTestUrlParam/ etc) with US for
// those are resolved to INDIA(IN) via cart/appData/ query params so that
// $locale.retrieve() called from middleware resolveLocale() method will resolve it to
// US. This helps app retrieve the griffin meta data/ content for US and renders
// initial page in US as if it rendering originally in US for IN users.
//
// Reason for Overriding:
// Since xoon is the process of being deprecated, and according to CAL search it
// only has 500 starts a day. And ROI of building this experience on xoon is low.
// so as per the product/ dev recommendation, user landing page is defaulted to US.
// see the below linked confluence for decision/ agreements.
//
// Context:
// As a part of IN KYC, checkout now requires a PayPal account with KYC
// verification and thats achieved via tesla flow -> detroit flow. So
// guest checkout flows needs to redirect to tesla flows for all IN user.
//
// Tickets/ confluence:
// https://paypal.atlassian.net/browse/LR-9854 - for legal approvals and
// figma links.
// https://paypal.atlassian.net/wiki/spaces/Checkout/pages/829816964/Spike+-+India+KYC#Decisions%2F-Agreements
*/
var resolveParams = function resolveParams(cart, appData, token) {
  var localeTest = _squid.$util.param('locale.test');
  var billingCountryFromCart = cart && cart.get('payer_info.billing_address.country_code');
  var shippingCountryFromCart = cart && cart.get('purchase.shipping_address.country_code');
  var merchantCountryFromAppData = appData && appData.get('merchant.merchant_country');
  var merchantLocaleFromAppData = appData && appData.get('merchant.merchant_locale');
  var countryX = _squid.$util.param('country.x') || _squid.$meta.query && _squid.$meta.query['country.x'];
  var localeX = _squid.$util.param('locale.x') || _squid.$meta.query && _squid.$meta.query['locale.x'];
  return {
    ipCountry: _squid.$meta.ipcountry,
    localeTestUrlParam: isLocaleQueryParamValid(localeTest, token) && localeTest.split('_')[1] === 'IN' ? 'en_US' : localeTest,
    checkoutBillingCountry: billingCountryFromCart === 'IN' ? 'US' : billingCountryFromCart,
    checkoutShippingCountry: shippingCountryFromCart === 'IN' ? 'US' : shippingCountryFromCart,
    merchantCountry: merchantCountryFromAppData === 'IN' ? 'US' : merchantCountryFromAppData,
    checkoutSessionLocale: isLocaleQueryParamValid(merchantLocaleFromAppData, token) && merchantLocaleFromAppData.split('_')[1] === 'IN' ? 'en_US' : merchantLocaleFromAppData,
    countryParam: countryX === 'IN' ? 'US' : countryX,
    localeParam: isLocaleQueryParamValid(localeX, token) && localeX.split('_')[1] === 'IN' ? 'en_US' : localeX
  };
};
var $Middleware = exports.$Middleware = [function checkToken() {
  var urlToken = _squid.$util.param('token');
  var bodyToken = _squid.$meta.token;
  if (urlToken !== _squid.$meta.token) {
    _logger.$logger.error('token_mismatch', {
      server: _squid.$meta.token,
      client: urlToken
    });
  }
  if (!urlToken && !bodyToken && !_squid.$util.param('data')) {
    throw new Error('No token or data found in page url');
  }

  // first set regular token (EC transactions)
  _angular.$rootScope.token = bodyToken || urlToken;
  _angular.$window.root = _angular.$rootScope;
}, function resolveLocale() {
  var models = {};
  if (_angular.$rootScope.token) {
    return (0, _squid.$populate)(models, {
      appData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve({
        contingencies: {
          DEFAULT: noop
        }
      }),
      cart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token)
    })["finally"](function () {
      var localeParams = resolveParams(models.cart, models.appData, _angular.$rootScope.token);

      // We need to have finally here instead of then, as we always want
      // locale to be resolved no matter failure of getCart or getAppData call
      return _squid.$locale.retrieve({
        params: _extends({}, localeParams)
      });
    });
  } else if (_squid.$util.param('data')) {
    var options = {
      params: {
        data: _squid.$util.param('data')
      }
    };
    return (0, _squid.$populate)(models, {
      guestAccountData: _index3.$GuestUpgradeModel.instance().retrieve({
        options: options,
        contingencies: {
          MAYFLY_ERROR: noop,
          DEFAULT: noop
        }
      })
    }).then(function () {
      return _squid.$locale.retrieve({
        params: {
          ipCountry: _squid.$meta.ipcountry,
          localeTestUrlParam: _squid.$util.param('locale.test'),
          countryParam: models.guestAccountData.get('user.country')
        }
      });
    });
  }
},
/*
 * checkFlowType: this function checks the flow type and adds call info logs
 *
 * We moved this fn from checkToken to a separate middleware, as we found an issue
 * when checkoutAppData call fails
 *
 * ISSUE FIXED: when checkoutAppData call fails with INVALID_RESOURCE_ID,
 * we redirect user to generie error page, and error page was shown without any
 * content/text, as resolveLocale middleware was never executed due to error thrown
 * in checkToken middleware function (error thrown by checkoutAppData failure)
 */
function checkFlowType() {
  // wps tokens are not preceeded with 'EC-'
  var wpsPattern = /^[0-9A-Z]{17}$/;

  // now test for WPS, set flags as necessary and log.
  // make sure ebay transactions aren't counted
  var isEbay = _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn();

  // identify WPS vs checkout-order token
  if (!isEbay && wpsPattern.test(_angular.$rootScope.token)) {
    return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
      // For WPS tokens appData.is_wps_flow() will always return 'true'.
      var isWPS = appData.is_wps_flow();
      _logger.$logger.info("xoon_" + (isWPS ? 'wps' : 'xo_order') + "_flow", {
        token: _angular.$rootScope.token
      });
    });
  }
}, function logout() {
  if (!_squid.$config.clientSideLogout) {
    return;
  }
  return _index4.$AuthModel.instance().retrieve().then(function (auth) {
    if (auth.logged_in || auth.email) {
      return auth.action('logout');
    }
  });
},
/**
 * Redirect back to Hermes if Android user with PayPal available through Android pay who
 * landed on Xoon due to BASL. 2 checks need to be done to determine if user has PayPal
 * in Android pay wallet: 1. chrome version >=58 (this version support payment api)
 * 2. call canMakePayment api call to validate if PayPal is already available in Android pay
 */
function checkAPayBASLRedirect() {
  if (!_squid.$config.apayEnabled) {
    return;
  }
  // Check if browser supports PaymentRequest API.
  if (!_xoAPayUtils.$xoAPayUtils.isAPayAPISupported()) {
    return;
  }
  var models = {};
  return (0, _squid.$populate)(models, {
    cart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()
  }).then(function () {
    // Do nothing for APay onboarding flow.
    if (models.cart.isWalletTokenization()) {
      return;
    }

    // Call PaymentRequest API to check if paypal as payment available
    return _xoAPayUtils.$xoAPayUtils.canMakeAPayPayment().then(function (result) {
      if (result) {
        return (0, _squid.$dispatch)('hermes', {
          token: _angular.$rootScope.token,
          hermesLoginRedirect: 'xoon',
          'locale.x': _squid.$locale.lang + "_" + _squid.$locale.country,
          'country.x': _squid.$locale.country
        });
      }
    });
  });
}, function xcomponent() {
  if (window.xprops && window.xprops.init) {
    return _angular.$q.all([_index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(), _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve()]).then(function (_ref) {
      var checkoutAppData = _ref[0],
        checkoutPayee = _ref[1];
      return window.xprops.init({
        paymentToken: _angular.$rootScope.token,
        merchantID: checkoutPayee.merchant.id,
        cancelUrl: checkoutAppData.urls.cancel_url
      });
    });
  }
}, function updateMerchantData() {
  if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
    return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
      return _index.$CheckoutClientDataModel.instance(_angular.$rootScope.token).retrieve().then(function (clientData) {
        var checkoutInputData = _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token);
        var identityData = clientData.merchantIdentityData();
        appData.merchant = {
          brand_name: identityData.brand_name,
          logo_url: identityData.logo_uri
        };
        appData.urls = {
          cancel_url: checkoutInputData.errorUrl('user_cancelled')
        };
      });
    });
  }
}, function checkJavaScriptInjection() {
  if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
    _logger.$logger.info('prox_signup_start', {
      cart_id: _angular.$rootScope.token
    });
    var redirectUri = _squid.$util.param('redirect_uri');
    if (redirectUri && redirectUri.indexOf('http') !== 0) {
      _logger.$logger.warn('XOON_FLOW_INVALID_REDIRECT_URI_JAVASCRIPT_INJECTION', {
        uri: redirectUri
      });
      return _angular.$q.reject(new _squid.$FallbackError({
        reason: 'invalidRedirectURI',
        product: 'ux'
      }));
    }
  }
}, function verifyRedirectURI() {
  if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
    var redirectUri = _squid.$util.param('redirect_uri');
    return _index.$CheckoutClientDataModel.instance(_angular.$rootScope.token).retrieve().then(function (clientData) {
      var isValidUri = clientData.validateRedirectUri(redirectUri) || {};
      if (!isValidUri.success) {
        _logger.$logger.warn('XOON_FLOW_INVALID_REDIRECT_URI', {
          uri: redirectUri
        });
        return _angular.$q.reject(new _squid.$FallbackError({
          reason: 'invalidRedirectURI',
          product: 'ux'
        }));
      }
    });
  }
},
// allow PROX to support country content separate from Hermes
function proxFallbackManager() {
  if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
    (0, _squid.$featureCountries)('guestFallback').forEach(function (country, index) {
      _squid.$config.features[country].guestFallback = false;
    });
  }
}, function handleTagManager() {
  _angular.$window.dataLayer = {
    // Two letter country code of the current page's content
    contentCountry: _squid.$locale.country.toLowerCase(),
    // Two letter locale
    contentLanguage: _squid.$locale.lang.toLowerCase()
  };
}, function setupMiniBrowser() {
  if (_squid.$util.param('data')) {
    return _miniBrowser.$MiniBrowser.initialize(_squid.$util.param('cancel_url'));
  }
  return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
    return _miniBrowser.$MiniBrowser.initialize(appData.urls.cancel_url);
  });
}, function logStart() {
  _logger.$logger.info('app_start_design', {
    is_directintegration: _miniBrowser.$MiniBrowser.isDirectIntegration ? 1 : 0,
    is_incontext: _miniBrowser.$MiniBrowser.isMiniBrowser || _miniBrowser.$MiniBrowser.isFrame ? 1 : 0
  });
}, function checkForSDK() {
  var isSDKintegration = window.name && window.name.indexOf('xcomponent__ppcheckout') === 0 || window.name.indexOf('zoid__ppcheckout') === 0 || _squid.$util.param('xcomponent') || _squid.$util.param('zoid');
  var sdkLoaded = window.paypal && window.xprops && window.paypal.Checkout && window.paypal.Checkout.isChild();
  if (isSDKintegration && !sdkLoaded) {
    throw new Error('Checkout loaded in an SDK integration, but no xprops found. Maybe the sdk script failed to load in the child window.');
  }
}];
angular.value("$Middleware", $Middleware);
_angular.$q;
_angular.$rootScope;
_angular.$window;
_logger.$logger;
_index.$CheckoutInputDataModel;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutCartModel;
_index2.$CheckoutPayeeModel;
_miniBrowser.$MiniBrowser;
_xoAPayUtils.$xoAPayUtils;
_index.$CheckoutClientDataModel;
_index3.$GuestUpgradeModel;
_index4.$AuthModel;
_squid.$FallbackError;
_squid.$config;
_squid.$meta;
_squid.$util;
_squid.$locale;
_squid.$populate;
_squid.$dispatch;
_squid.$featureCountries;


//////////////////
// WEBPACK FOOTER
// ./js/lib/middleware.js
// module id = ./js/lib/middleware.js
// module chunks = 0